import { render, staticRenderFns } from "./diy2.vue?vue&type=template&id=38730df6&scoped=true&"
import script from "./diy2.vue?vue&type=script&lang=js&"
export * from "./diy2.vue?vue&type=script&lang=js&"
import style0 from "./diy2.vue?vue&type=style&index=0&id=38730df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38730df6",
  null
  
)

export default component.exports